import {Machine} from './machine';

export class MachineWrapper {

    public machines: Array<Machine>;
    public lastKeyEvaluated : any;
    
}